import { render, staticRenderFns } from "./loader-cmp.vue?vue&type=template&id=6b8e76e9&scoped=true"
import script from "./loader-cmp.vue?vue&type=script&lang=js"
export * from "./loader-cmp.vue?vue&type=script&lang=js"
import style0 from "./loader-cmp.vue?vue&type=style&index=0&id=6b8e76e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8e76e9",
  null
  
)

export default component.exports